import { render, staticRenderFns } from "./VerPedido.vue?vue&type=template&id=7a4d2f17"
import script from "./VerPedido.vue?vue&type=script&lang=js"
export * from "./VerPedido.vue?vue&type=script&lang=js"
import style0 from "./VerPedido.vue?vue&type=style&index=0&id=7a4d2f17&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports